import { render, staticRenderFns } from "./Ugu.vue?vue&type=template&id=38a2d1f0&"
import script from "./Ugu.vue?vue&type=script&lang=js&"
export * from "./Ugu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports